<div class="container" *ngIf="data.create">
    <div class="text-center"><h3>Configuration is saved successfully.</h3></div>
    <div class="text-center p-1">
        <button type="submit" class="btn btn-success me-3 my-1 submit-button"  (click)="home()"><em class="fa fa-home"></em> Home</button>
        &nbsp;
        <button type="submit" class="btn btn-success me-3 my-1 submit-button" (click)="create()">Create Another Form</button>
    </div>
</div>
<div class="container" *ngIf="data.edit">
    <div class="text-center"><h3>Configuration is updated successfully.</h3></div>
    <div class="text-center p-1">
        <button type="submit" class="btn btn-success me-3 my-1 submit-button"  (click)="view()"><em class="fa fa-home"></em> Close</button>
    </div>
</div>
<div class="container" *ngIf="data.api">
    <div class="text-center"><h3>
        Configuration JSON is not found.
    </h3></div>
    <div class="text-center p-1">
        <button type="submit" class="btn btn-success me-3 my-1 submit-button"  (click)="close()"> Close</button>
      
    </div>
</div>

<div class="container" *ngIf="data.apiRiskInfo">
    <div class="text-center"><h3>
         Risk Information is not found.
    </h3></div>
    <div class="text-center p-1">
        <button type="submit" class="btn btn-success me-3 my-1 submit-button"  (click)="close()"> Close</button>
      
    </div>
</div>


<div class="container" *ngIf="data.sent">
    <div class="text-center"><h3>
       {{'resend_success' | translate}}&nbsp; <span class="text-primary">{{data.emailID}}</span>
    </h3></div>
    <div class="text-center p-1">
        <button type="submit" class="btn btn-success me-3 my-1 submit-button"  (click)="close()"> {{'ok' | translate}}</button>
    </div>
</div>

<div class="container" *ngIf="data.userAction">
    <div class="text-center">
        <div class="text-success m-2">
            <em class="fa fa-check-circle font-size-25px"></em>
          </div>
        <h3 *ngIf="data.userAction == 'blocked'">{{'user_blocked' | translate}}</h3>
        <h3 *ngIf="data.userAction == 'unblocked'">{{'user_unblocked' | translate}}</h3>
        <h3 *ngIf="data.userAction == 'unLock'">{{'user_unlock' | translate}}</h3>
        <h3 *ngIf="data.userAction == 'deactivate'">{{'user_deactivate' | translate}}</h3>
    </div>
    <div class="text-center p-1">
        <button type="submit" class="btn btn-success me-3 my-1 submit-button"  (click)="close()"><em class="fa fa-thumbs-up fa-fw"></em>&nbsp; {{'ok' | translate}}</button>
    </div>
</div>